import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const images = [
    'IMG_1302.jpg',
    'IMG_1330.jpg',
    'IMG_1333.jpg'
];

const ChapelSlideshow = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // Change image every 5 seconds
        return () => clearInterval(interval);
    }, []);

    return (
        <div className='slideshow-container'>
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`slide ${index === currentIndex ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${image})` }}
                />
            ))}
        </div>
    );
};

export default ChapelSlideshow;
